import { useRef } from "react";

// Returns a ref to attach to elements with className="reveal"
// The global observer in App.js handles adding .active
export function useReveal() {
  return useRef(null);
}
